import { hookifySdk } from '@long-game/game-client';
export const sdkHooks = hookifySdk();
//# sourceMappingURL=sdkHooks.js.map